
var Model = require("../types/Model.js");
var loadImage = require("../../polyfills/LoadImage.js");
var xtend = require("xtend");
var Promise = require("promise");
var isObject = require("isobject");

module.exports = Model({
	name: "groupchat",
	_group: null,
	_groupchat_tracker: null,
	_updated_group: null,
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate,
	send_message: send_message,
	scroll_down: scroll_down,
	load_page: load_page,
	handle_new_message: handle_new_message,
	close_group_messages: close_group_messages,
	go_home: go_home,
	emit_network_toast: emit_network_toast,
	track_events: track_events,
	close_upload_dialog: close_upload_dialog,
	clear_pending_message: clear_pending_message
});

function init() {
	this._group = null;
	this._groups = null;
	this._updated_group = null;
	this._groupchat_tracker = this.dispatcher.createTracker();
	this.push({
		list: [],
		pendingList: [],
		group: null,
		updated_group: null,
		new_content: "",
		texting: "",
		loadMore: false
	});
}

function uninit() {
	this._groupchat_tracker.off();
	this._groupchat_tracker = null;
}

function listeners() {
	return {
		"people:updated": Model.makeRecalculator("people"),
		"groups:updated": handle_groups_updated,
		"mqtt:$/message/read/from": handle_message_read,
		"calling:state:idle": recalculate,
		"meetings:stop": recalculate
	};
}

function triggers() {
	return {
		"send": send_message,
		"create": create_group,
		"view": view_group,
		"next": load_next_page,
		"close": close_group_messages,

		"add:open": open_adding,
		"add": add_contact,

		"edit": update_group,
		"edit:cancel": close_page,

		"upload:start": upload_start,
		"upload:confirm": upload_confirm,
		"upload:finish": upload_finish,
		"upload:cancel": close_upload_dialog,

		"leave:start": leave_group_start,
		"leave:accept": leave_group,
		"leave:cancel": leave_group_cancel,

		"remove:member:start": remove_member_start,
		"remove:member:accept": remove_member,
		"remove:member:cancel": remove_member_cancel,

		"remove:group:start": start_removing_group,
		"remove:group:accept": accept_removing_group,
		"remove:group:cancel": close_page
	};
}

async function recalculate() {
	var users = this._people;
	var group = this._group;
	var messages = this.data.list;
	var personalId = this.config.id;
	var updated_group = this._updated_group;
	if (!group) return;
	if (!group.members) return;

	if (updated_group != null) {
		var membersToAdd = updated_group.members.filter(
			(updatedMember) =>
				!group.members.some((member) => member._id === updatedMember._id)
		);
		var membersToRemove = group.members.filter(
			(member) =>
				!updated_group.members.some(
					(updatedMember) => updatedMember._id === member._id
				)
		);

		if (membersToAdd.length > 0) {
			group.members = group.members.concat(membersToAdd);
		}

		if (membersToRemove.length > 0) {
			group.members = group.members.filter(
				(member) =>
					!membersToRemove.some(
						(removedMember) => removedMember._id === member._id
					)
			);
		}
	}

	var members = group?.members.map(function (member) {
		if (isObject(member))
			return users[member._id] || { _id: member._id, fname: "...", lname: "" };
		return users?.[member] || { _id: member, fname: "...", lname: "" };
	});

	var newMessages = messages.map(
		function (message, index) {
			var update = {};
			if (message.type.indexOf("systemmessage") !== -1) {
				var data = message.metadata.data;
				var person;
				if (isObject(data)) person = users[data._id];
				else person = users[data];
				if (!person) return message;
				update = {
					metadata: {
						type: message.metadata.type,
						data: person,
					},
				};
			} else {
				var messageFrom;
				if (isObject(message.from)) messageFrom = users[message.from._id];
				else messageFrom = users[message.from];
				if (!messageFrom) return message;
				update = {
					from: messageFrom,
				};
			}

			var newRead;
			var from = message.from;
			if (index === messages.length - 1 && Array.isArray(message.read))
				newRead = message.read
					.filter(function (member) {
						if (isObject(member)) return member._id !== personalId;
						else return member !== personalId;
					})
					.filter(function (member) {
						if (isObject(member))
							return isObject(from)
								? member._id !== from._id
								: member._id !== from;
						else return isObject(from) ? member !== from._id : member !== from;
					})
					.map(function (member) {
						var personObj;
						if (isObject(member)) personObj = users[member._id];
						else personObj = users[member];
						if (!personObj) return member;
						else return personObj;
					});
			if (!newRead && from === "system" && typeof message.read === "boolean"){
				newRead = [users[personalId]];
			}
			update.read = newRead;
			return xtend(message, update);
		}.bind(this)
	);

	var texting;
	try {
		const result = await this.api.persiststorage.getData(this.config.id, {
			targetId: this._group._id,
		});
		texting = result.persistStorage?.[0]?.data.message;
	} catch (error) {
		console.error(error);
	}

	var groupUpdate = {
		members: members,
	};

	var updatedGroup = xtend(group, groupUpdate);
	var update = {};

	var shouldUpdate = false;

	if (updatedGroup !== group) {
		shouldUpdate = true;
		update.group = updatedGroup;
	}

	if (newMessages.length > 0) {
		shouldUpdate = true;
		update.list = newMessages;
	}

	if (this.data.texting !== texting) {
		update.texting = texting;
		shouldUpdate = true;
	}

	if (shouldUpdate) {
		this.extend(update);
		this._group = updatedGroup;
	}
}

function start_removing_group() {
	this.extend({
		removing: true
	});

	this.emit("usermetrics:trigger:track", "begin removing groupchat", {
		group: this._group._id
	});
}

function accept_removing_group() {
	var group = this._group;
	var group_id = group._id;

	this.api.groupchat.remove(group_id);

	this.emit("usermetrics:trigger:track", "remove groupchat", {
		group: group_id
	});
}

function handle_groups_updated(groups) {
	var group = this._group;

	var ids = groups.reduce(function (idArray, element) {
		return idArray.concat(element.members);
	}, []);

	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});

	this._groups = makeIdMap(groups);

	if (!group) return;

	var newGroup;
	if (Array.prototype.find)
		newGroup = groups.find(function (element) {
			return element._id === group._id;
		});
	else
		newGroup = findGroup(groups, group);

	if (!newGroup) {
		this.go_home();
		this.close_group_messages();
		return;
	}

	newGroup.members = group.members;

	var update = xtend(group, newGroup);
	this._group = update;
	this.extend({
		group: update
	});

	this.recalculate();
}

function handle_message_read(data) {
	var group = data.group;
	var from = data.from;
	var currentGroup = this._group;
	var list = this.data.list;

	if (currentGroup && group !== currentGroup._id)
		return;

	var newList = list.map(function (message, index) {
		if (index === (list.length - 1)) {
			var read = message.read.concat(from);
			return xtend(message, {
				read: read
			});
		} else {
			return message;
		}
	});

	this.extend({
		list: newList
	});

	this.recalculate();
	this.scroll_down();
}

function handle_new_message(message) {
	var group = this._group;
	var group_id = group._id;

	if (message.group !== group_id)
		return;

	var currentList = this.data.list;

	this.extend({
		list: currentList.concat(timestampify(message))
	});

	this.recalculate();
	this.scroll_down();
	return this.api.groupchat.read(group_id);
}

function upload_start() {
	this.extend({
		uploading: true
	});
	this.emit("usermetrics:trigger:track", "begin upload file to groupchat", {
		group: this._group._id
	});
}

function close_upload_dialog() {
	this.extend({
		uploading: false,
		file: null,
		fileImage: null
	});
	this.emit("usermetrics:trigger:track", "close upload file to groupchat popup", {
		group: this._group._id
	});
}

function upload_confirm(data) {
	var file = data.file;
	loadImage(file).then(function (image) {
		this.extend({
			uploading: false,
			file: file,
			fileImage: image
		});
	}.bind(this));
	this.emit("usermetrics:trigger:track", "confirm upload file to groupchat", {
		group: this._group._id
	});
}

function upload_finish() {
	var file = this.data.file;
	var group = this._group._id;

	var message = {
		file: file
	};

	this.extend({
		pendingList: this.data.pendingList.concat(message)
	});
	this.scroll_down();
	this.close_upload_dialog();
	return this.api.groupchat.send.file(file, group)
		.then(clear_pending_message.bind(this, message))
		.catch(handle_send_error.bind(this, message));
}

function open_adding() {
	this.dispatch("adding");
	this.emit("usermetrics:trigger:track", "begin adding member to groupchat", {
		group: this._group._id
	});
}

function add_contact(contact) {
	var newContact = contact.contact;
	var group_id = this._group._id;

	this.emit("usermetrics:trigger:track", "add member to groupchat", {
		group: group_id,
		who: newContact
	});

	return this.api.groupchat.members.add(group_id, newContact)
		.then(hide.bind(this));
}

function send_message(message) {
	var group = this._group;
	var group_id = group._id;
	var message_text = message.content;
	this.extend({
		new_content: "",
		texting: "",
		pendingList: this.data.pendingList.concat(message)
	});
	this.scroll_down();
	this.emit("persiststorage:delete", {
		dataId: group_id
	});

	this.emit("usermetrics:trigger:track", "send group message", {
		group: group_id,
	});

	return this.api.groupchat.send.message(group_id, message_text)
		.then(clear_pending_message.bind(this, message))
		.catch(handle_send_error.bind(this, message));
}

function leave_group_start() {
	this.extend({
		leaving: true
	});
	this.emit("usermetrics:trigger:track", "begin leave groupchat", {
		group: this._group._id
	});
}

function leave_group() {
	var group = this._group;
	var group_id = group._id;
	this.emit("usermetrics:trigger:track", "leave groupchat", {
		group: group_id
	});
	return this.api.groupchat.leave(group_id)
		.then(hide.bind(this));
}

function leave_group_cancel() {
	this.extend({
		leaving: false
	});
	this.emit("usermetrics:trigger:track", "cancel leave groupchat", {
		group: this._group._id
	});
}

function remove_member() {
	var group = this._group;
	var group_id = group._id;
	var member_id = this.data.removingMember._id;
	this.emit("usermetrics:trigger:track", "remove member from groupchat", {
		group: group_id,
		who: member_id
	});
	return this.api.groupchat.members.remove(group_id, member_id)
		.then(hide.bind(this));
}

function hide() {
	this.extend({
		removing: false,
		removingMember: false,
		leaving: false
	});
	this.dispatch("closed");
}

function close_page() {
	let message = "cancel edit groupchat";
	!this._group && (message = "cancel create groupchat");
	this.removing && (message = "cancel remove groupchat");
	this.removingMember && (message = "cancel remove member from groupchat");
	this.leaving && (message = "cancel leave groupchat");
	this.emit("usermetrics:trigger:track", message, {
		group: this._group?._id
	});
	this.extend({
		removing: false,
		removingMember: false,
		leaving: false
	});
	this.dispatch("closed");
}

function create_group(settings) {
	this.dispatch("creating");
	var name = settings.name;
	var description = settings.description;
	return this.api.groupchat.create(name, description)
		.then((result)=>{
			this.emit("usermetrics:trigger:track", "create groupchat", {
				groupId: result.group
			});
		})
		.then(hide.bind(this));
}

function update_group(settings) {
	this.dispatch("creating");
	var name = settings.name;
	var description = settings.description;
	var group = this._group?._id;
	this.emit("usermetrics:trigger:track", "edit groupchat", {
		group: group
	});
	return this.api.groupchat.update(group, name, description)
		.then(hide.bind(this));
}

function view_group(group) {
	group = group.group;
	this._group = group;
	var group_id = group._id;
	this.emit("messages:trigger:default", { id: group_id });
	this.track_events(group_id);

	this.api.groupchat.data(group_id)
		.then(set_group.bind(this))
		.then(Promise.all([
			this.load_page(0),
			this.api.groupchat.read(group_id),
			this.recalculate()
		])).then(scroll_down.bind(this));

	this.dispatch("opened", {
		group: group
	});

	this.emit("usermetrics:trigger:track", "open groupchat", {
		group: group_id
	});
}

function set_group(groupData) {
	this._group = groupData;
	this.extend({
		group: groupData
	});
}

function load_next_page() {
	var page = this.data.page + 1;
	this.emit("usermetrics:trigger:track", "load more group messages", {
		page: page,
		group: this._group._id
	});
	return this.load_page(page);
}

function load_page(page) {
	this.emit("orientationlocker:trigger:lock", { orientation: "portrait" });
	var group = this._group;
	var group_id = group._id;
	this.emit("save:trigger:start");
	return this.api.groupchat.history(group_id, page)
		.then(add_new_messages.bind(this, page))
		.catch(handle_load_error.bind(this));
}

function add_new_messages(page, list) {
	var oldMessages = this.data.list;
	var loadMore = list.length >= 20;

	var ids = list.map(function (message) {
		if (message.from === "system")
			return message.metadata.data;
		return message.from;
	});

	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});

	var processedList = list.reverse().map(timestampify);

	var update = {
		page: page,
		list: page ? processedList.concat(oldMessages) : processedList,
		loadMore: loadMore
	};
	this.extend(update);
	this.emit("save:trigger:finish");
	this.recalculate();
}

function close_group_messages() {
	var tracker = this._groupchat_tracker;
	tracker.off();
	this._group = null;
	this.extend({
		list: [],
		group: null,
		removing: false,
		uploading: false,
		loadMore: false,
	});
	this.emit("orientationlocker:trigger:unlock");
}

function remove_member_start(member) {
	this.extend({
		removingMember: member.member
	});
	this.emit("usermetrics:trigger:track", "begin removing member from groupchat", {
		who: member?.member?._id
	});
}

function remove_member_cancel() {
	this.extend({
		removingMember: false
	});

	this.emit("usermetrics:trigger:track", "cancel remove member from groupchat");
}

function go_home() {
	this.emit("desktop:trigger:page:home");
	this.emit("orientationlocker:trigger:unlock");
}

function handle_load_error(error) {
	console.error("Couldn't load messages:", error);
	this.emit("save:trigger:finish");
	this.emit_network_toast();
}

function handle_send_error(message, error) {
	console.error("Couldn't send message:", error);
	this.emit_network_toast();

	this.clear_pending_message(message);
}

function handle_member_added(member) {
	var group = this._group;
	var member_id = member.member;
	var users = this._people;

	this.emit("people:trigger:add", {
		lean: true,
		who: member_id
	});

	var members = group.members;

	var person = users[member_id] || { _id: member_id, fname: "...", lname: "" };

	var newMembers = members.concat(person);
	var newTo = newMembers;

	var update = {
		members: newMembers
	};

	var updatedGroup = xtend(group, update);

	this._group = updatedGroup;
	this._updated_group = updatedGroup;
	this.extend({
		group: updatedGroup,
		updated_group: updatedGroup,
		to: newTo
	});
	this.recalculate();
}

function handle_member_removed(member) {
	var group = this._group;
	var member_id = member.member;
	var members = group.members;

	var newMembers = members.filter(function (person) {
		return person._id !== member_id;
	});

	var newTo = newMembers;

	var update = {
		members: newMembers
	};

	var updatedGroup = xtend(group, update);

	this._group = updatedGroup;
	this._updated_group = updatedGroup;
	this.extend({
		group: updatedGroup,
		updated_group: updatedGroup,
		to: newTo
	});
	this.recalculate();
}

function clear_pending_message(message) {
	var pendingList = this.data.pendingList.filter(function (pendingMessage) {
		return pendingMessage !== message;
	});
	this.extend({
		pendingList: pendingList
	});
}

function emit_network_toast() {
	this.emit("toast:trigger:show", {
		content: "groupchat.errornetwork",
		style: "error",
		immediate: true
	});
}

function track_events(group_id) {
	var tracker = this._groupchat_tracker;
	tracker.off();
	tracker.on("mqtt:gc/" + group_id + "/message", handle_new_message.bind(this));
	tracker.on("mqtt:gc/" + group_id + "/members/added", handle_member_added.bind(this));
	tracker.on("mqtt:gc/" + group_id + "/members/removed", handle_member_removed.bind(this));
}

function timestampify(item) {
	var attachment = item.attachment;
	var expires_at;
	if (attachment)
		expires_at = attachment.expires_at;
	return xtend(item, {
		expiry: timestamp(expires_at),
		date_expiry: formatDate(expires_at),
		timestamp: timestamp(item.created_at),
		formatted_date: formatDate(item.created_at)
	});
}

// Converts a date timestamp into a human readable timestamp
function timestamp(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getHours());
	res += ":" + padNumber(d.getMinutes());
	return res;
}

// Converts a date timestamp into a human readable date
function formatDate(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getDate());
	res += "/" + padNumber(d.getMonth() + 1);
	return res;
}

// Pads numbers less than 10 with a 0
function padNumber(number) {
	if (number < 10) return "0" + number;
	return number;
}

function scroll_down() {
	setTimeout(function () {
		this.dispatch("scroll");
	}.bind(this), 500);
}

function findGroup(groups, group) {
	return groups.filter(function (_group) {
		return _group._id === group._id;
	})[0];
}

function makeIdMap(elements) {
	return elements.reduce(function (map, element) {
		map[element._id] = element;
		return map;
	}, {});
}
